import { render, staticRenderFns } from "./BafiClientSelect.vue?vue&type=template&id=a8e3d418&"
import script from "./BafiClientSelect.vue?vue&type=script&lang=js&"
export * from "./BafiClientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports